import {
  MenuItemProps,
  WSContextMenu,
  WSElementProps,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import cn from "classnames";

import styles from "./styles.module.scss";

interface DropdownButtonProps extends WSElementProps {
  text: string;
  onClick(): void;
  menuItems: MenuItemProps[];
  fullWidth?: boolean;
  name?: string;
  title?: string;
  testId?: string;
  disabled?: boolean;
}

const DropdownButton: React.FC<DropdownButtonProps> = ({
  text,
  onClick,
  menuItems,
  fullWidth,
  name,
  title,
  testId,
  disabled,
  ...otherProps
}) => {
  const interior = (
    <WSFlexBox
      className={cn(styles.buttonActions, disabled && styles.disabled)}
      alignItems="stretch"
      {...otherProps}
    >
      <WSText.Heading4
        as="div"
        align="center"
        color="white"
        className={styles.buttonActionsText}
        py="S"
        px="M"
        onClick={disabled ? undefined : onClick}
        data-testid={testId}
      >
        {text}
      </WSText.Heading4>
      <WSFlexBox.Center px="S">
        <WSIcon name="dropDown" color="white" size="S" />
      </WSFlexBox.Center>
    </WSFlexBox>
  );

  if (!disabled) {
    return (
      <WSContextMenu
        isSameWidthAsTrigger
        className={cn(styles.buttonActionsWrapper, {
          [styles.fullWidth]: fullWidth
        })}
        name={name}
        title={title}
        renderMenuTriggerView={interior}
        defaultPlacement="bottom-start"
        menuItems={menuItems}
      />
    );
  }
  return interior;
};

export default DropdownButton;
